module.exports = __webpack_public_path__ + "static/media/line.fd3d58d0.svg";